export default __webpack_public_path__ + "static/awbi-transparent-24c105dcf4b75d7f7b01dbf25d6b9614.png";